import React from 'react'
//custom imports
import styles from './heading.module.scss';

const Heading = (props)=>{
    const {text = 'NA'} = props
    return <div className={styles.heading_text}>{text}</div>
}

export default Heading